import { parseISO } from "date-fns";

import { formatInTimeZone } from "../util/formatInTimezone";

const useTimezoneDate = () => {
  const getDateValueUtcTimezone = (value = "", format?: string) => {
    return formatInTimeZone(format ?? "yyyy-MM-dd", "UTC", value);
  };

  const getTimeValueUtcTimezone = (value = "") => {
    return formatInTimeZone("HH:mm", "UTC", value);
  };

  const getDateValue = (value = "") => {
    return formatInTimeZone("yyyy-MM-dd", Intl.DateTimeFormat().resolvedOptions().timeZone, value);
  };

  const getSaveDateValue = (dateValue: string) =>
    dateValue
      ? formatInTimeZone("yyyy-MM-dd'T'HH:mm:ss.SSSxxx", "UTC", parseISO(dateValue))
      : undefined;

  return {
    getDateValue,
    getSaveDateValue,
    getDateValueUtcTimezone,
    getTimeValueUtcTimezone,
  };
};

export default useTimezoneDate;
